import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import {projectName} from "@/utils/config";

export default [
  {
    path: '/IFPageOneHFortySevenPreLogin',
    name: 'IFPageOneHFortySevenPreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFortySeven/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHFortySevenLogin' ||
        from.path === '/IFPageOneHFortySevenLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHFortySevenLogin',
    name: 'pageOneHFortySevenLogin',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHFortySeven/login.vue'),
  },
  {
    path: '/IFPageOneHFortySevenLoginLoading',
    name: 'pageOneHFortySevenLoginLoading',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHFortySeven/loginLoading.vue'),
  },
  {
    path: '/IFPageOneHFortySevenLeaveInfo',
    name: 'pageOneHFortySevenLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFortySeven/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHFortySevenResult',
    name: 'pageOneHFortySevenResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFortySeven/result.vue'),
  },
  {
    path: '/IFPageOneHFortySevenLoading',
    name: 'pageOneHFortySevenLoading',
    component: () => import('@/pages/pageListAll/pageOneHFortySeven/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageOneHFortySevenLoginSecond',
    name: 'pageOneHFortySevenLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHFortySeven/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFortySevenOnline',
    name: 'pageOneHFortySevenOnline',
    component: () => import('@/pages/pageListAll/pageOneHFortySeven/online.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageOneHFortySevenLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageOneHFortySevenGuide',
    name: 'pageOneHFortySevenLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneHFortySeven/guide.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  {
    path: '/IFPageOneHFortySevenCar',
    name: 'pageOneHFortySevenCar',
    component: () => import('@/pages/pageListAll/pageOneHFortySeven/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageOneHFortySevenCarDetails',
    name: 'pageOneHFortySevenCarDetails',
    component: () => import('@/pages/pageListAll/pageOneHFortySeven/carDetails.vue'),
    meta: {
      title: '申请结果',
    },
  },
  {
    path: '/IFPageOneHFortySevenBlank',
    name: 'pageOneHFortySevenBlank',
    component: () => import('@/pages/pageListAll/pageOneHFortySeven/blank.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFortySevenOnlineTab',
    name: 'pageOneHFortySevenOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneHFortySeven/onlineTab.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFortySevenOnlineAd',
    name: 'pageOneHFortySevenOnlineAd',
    component: () => import('@/pages/pageListAll/pageOneHFortySeven/onlineAd.vue'),
    meta: {
      title: projectName,
    },
  },
];
